import { Suspense } from "react";
import { useTranslation } from "react-i18next";
import SeoHead from "./SeoHead";
import { getCanonicalUrl } from "../config/site";

function RouteSeo({
  title,
  titleKey,
  fullTitle = false,
  description,
  descriptionKey,
  canonicalPath,
  noindex = false,
  fallback,
  children,
}) {
  const { t } = useTranslation();

  return (
    <>
      <SeoHead
        title={title || (fullTitle ? t(titleKey) : `${t(titleKey)} — Ranobe Life`)}
        description={descriptionKey ? t(descriptionKey) : description}
        canonical={canonicalPath ? getCanonicalUrl(canonicalPath) : undefined}
        robots={noindex ? "noindex,nofollow" : undefined}
      />
      <Suspense fallback={fallback}>{children}</Suspense>
    </>
  );
}

export default RouteSeo;